export enum IndexeddbBackupKeys {
    Initialize = "Initialize",
    Close = "Close",
    FetchBackupState = "FetchBackupState",
    ClearBackup = "ClearBackup",
    BackupFormatProperties = "BackupFormatProperties",
    FetchFormatProperties = "FetchFormatProperties",
    BackupChunk = "BackupChunk",
    FetchChunks = "FetchChunks",
    FetchCountOfItemsFromStore = "FetchCountOfItemsFromStore",
    EncodeChunk = "EncodeChunk",
    BackupItemToStore = "BackupItemToStore",
    FetchItemsFromStore = "FetchItemsFromStore"
};